<div class="logo col-12  d-flex justify-content-center">
    <img class="logotop"
        src="https://www.americancruiselines.com/libraries/acl/images/style-assets/original-site/logos/logo.png">
</div>